// Copyright (c) 2016 Deere & Company

import SearchResults, {getDefaultState} from '../state/search-results';
import actions from '../../actions-list';

const updateFilteredSearchResults = (state, action) =>
    SearchResults.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.FILTER_PIP_SEARCH_RESULTS]: updateFilteredSearchResults
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/pip-search/reducers/filtered-search-results.js